import { AppVersion } from "@app/core/version/domain/model/app-version";

export class GetMimumVersionMapper {
  static deserialize(response: any): AppVersion {
    return {
      BUILD: response.build,
    };
  }
}
